module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-600.woff?e3bbab8d37ba508809f78c4baf02ebdb";